import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import es from './es.json';
import ca from './ca.json';


i18n.use(initReactI18next)
  .use(LanguageDetector)
  .init({
    compatibilityJSON: 'v3',
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'ca'],
    resources: {
      en: en,
      es: es,
      ca: ca
    },
    detection: {
      caches: []
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;